// -------------------------------
// SALARY STRUCTURE AI INTERFACES
// -------------------------------
export interface PendingSalaryStructure {
    employee_id?: number;
    pay_scale_id?: number;
    start_date?: string;
    end_date?: string;
    overtime_pay_id?: number | null;
    status?: "active" | "inactive";
}

export interface PendingDeleteSalaryStructure {
    awaitingInfo?: boolean;
}
export const startCreateSalaryStructureFlow = (
    setPending: (data: PendingSalaryStructure | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPending({});
    pushAIChat("Sure. Which employee should I create a salary structure for?");
    speak("Which employee should I create a salary structure for?");
            window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "employee-for-structure" }
            })
        );
};
export const processPendingSalaryStructure = (
    text: string,
    pending: PendingSalaryStructure,
    setPending: (data: PendingSalaryStructure | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    if (!pending.start_date) {
        if (isNaN(Date.parse(text))) {
            pushAIChat("Please provide a valid start date.");
            speak("Please provide a valid start date.");
            return;
        }

        setPending({ ...pending, start_date: text });
        pushAIChat("What should be the end date?");
        speak("What should be the end date?");
        return;
    }

    if (!pending.end_date) {
        if (isNaN(Date.parse(text))) {
            pushAIChat("Please provide a valid end date.");
            speak("Please provide a valid end date.");
            return;
        }

        const finalPayload: PendingSalaryStructure = {
            ...pending,
            end_date: text,
            status: "active"
        };

        pushAIChat("Opening salary structure form with provided details.");
        speak("Opening salary structure form.");

        //SEND TO GLOBAL MASTER
        window.dispatchEvent(
            new CustomEvent("ai-create-salary-structure-request", {
                detail: finalPayload
            })
        );

        setPending(null);
        return;
    }
};
